import * as React from 'react';
import { Tooltip } from '@mui/material';
import fonts from 'styles/typography.module.css';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';

interface Props {
  children: React.ReactNode;
  show?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

export const InformationalTooltip: React.FC<Props> = (props) => {
  const { children, show, size, className } = props;

  let width = 1.3;
  switch (size) {
    case 'sm':
      width = 1;
      break;
    default:
      break;
  }

  return (
    <Tooltip
      title={<h4>{children}</h4>}
      classes={{
        tooltip: `bg-gray-500 text-white p-3 shadow-md ${fonts.font}`,
      }}
    >
      <QuestionMarkCircleIcon
        width={`${width}em`}
        // Defaults to show
        className={`text-gray-300 hover:text-gray-500 cursor-pointer transition ${
          show === false ? 'opacity-0 pointer-events-none' : 'opacity-100 pointer-events-auto'
        } ${className}`}
      />
    </Tooltip>
  );
};
InformationalTooltip.displayName = 'InformationalTooltip';
